import type { Task, User } from '../../types';

export function reviewerLabel(user: User): string {
  const name = user.displayName?.trim();
  const email = user.email?.trim();
  if (name && email && name.toLowerCase() !== email.toLowerCase()) {
    return `${name} (${email})`;
  }
  return name || email || user.uid;
}

/**
 * Users an admin may assign an in-review task to: the campaign's configured
 * reviewers plus every admin (admins are authorized to review any campaign).
 * Mirrors the eligibility check in the `assignReview` command.
 */
export function campaignReviewers(users: User[], campaignId: string): User[] {
  if (!campaignId) return [];
  return users
    .filter((user) => user.isAdmin === true
      || (user.isReviewer === true && (user.reviewCampaignIds ?? []).includes(campaignId)))
    .sort((left, right) => reviewerLabel(left).localeCompare(reviewerLabel(right)));
}

export function assignedReviewerLabel(task: Task, users: User[]): string {
  if (!task.reviewerId) return 'Unassigned';
  const reviewer = users.find((user) => user.uid === task.reviewerId);
  return reviewer ? reviewerLabel(reviewer) : task.reviewerName?.trim() || task.reviewerId;
}
